/**
 * Переводы: украинский.
 *
 * ⚠️ КЛЮЧИ ОБЯЗАНЫ СОВПАДАТЬ ВО ВСЕХ ЧЕТЫРЁХ ЯЗЫКАХ. Пропущенный ключ не
 * ломает сборку и не роняет игру — на экране просто появляется сам ключ
 * вида «menu.shop_sell», и заметить это можно только глазами и только на
 * том языке, на котором никто не играет. Проверка парности — в index.ts
 * этой папки.
 *
 * ⚠️ РАЗДЕЛЕНО ПО ЯЗЫКАМ, А НЕ ПО РАЗДЕЛАМ ИГРЫ. Раздел («меню», «снасть»)
 * при переводе не нужен: переводчик работает с одним языком целиком, а
 * править разом четыре языка приходится только при добавлении ключа — и
 * тогда четыре файла рядом удобнее, чем четыре места в файле на 1845 строк.
 */
import { ТОВАРЫ_UK } from './goods-uk.js';
import { РЫБЫ_UK } from './species-north-uk.js';
import { МИР_UK } from './species-world-uk.js';

export const uk: Record<string, string> = {
  'fish.unknown': 'Риба на гачку',
  ...ТОВАРЫ_UK,
  ...РЫБЫ_UK,
  ...МИР_UK,
  'hud.anglers_online': 'Рибалок онлайн: {n}',
  'loader.ключ': 'Перевіряю квиток',
  'loader.база': 'Відкриваю журнал',
  'loader.движок': 'Розмотую котушку',
  'loader.сцена': 'Збираю снасть',
  'loader.локация': 'Іду до води',
  'loader.берег': 'Обираю місце',
  'auth.subtitle': 'Вхід у гру',
  'auth.tab_login': 'Вхід',
  'auth.tab_register': 'Реєстрація',
  'auth.name': "Ім'я",
  'auth.name_hold': 'Як вас звати на воді',
  'auth.name_hint': "Інші гравці бачитимуть це ім'я",
  'auth.email': 'Пошта',
  'auth.email_hint': 'Вашу пошту ніхто не побачить — це приватні відомості',
  'auth.password': 'Пароль',
  'auth.pass_hint': 'Тільки латиниця, обов’язкові цифра та велика літера',
  'auth.password2': 'Повторіть пароль',
  'auth.pass2_hint': 'Удруге — щоб одруківка не замкнула вхід',
  'auth.login_btn': 'Увійти',
  'auth.register_btn': 'Створити акаунт',
  'auth.pass_min': 'Щонайменше 6 символів',
  'set.terrain_range': 'Дальність рельєфу',
  'set.terrain_range_hint': 'Найсильніший вплив на кадр: рельєф займає більше половини',
  'set.range_near': 'Ближня',
  'set.range_normal': 'Звичайна',
  'set.range_far': 'Далека',
  'set.antialias': 'Згладжування',
  'set.antialias_hint': 'Прибирає квадратики від розтягування та сходинки на краях; платиться пікселями',
  'set.aa_off': 'Вимк',
  'set.aa_soft': 'М’яке',
  'set.aa_full': 'Повне',
  'set.render_scale': 'Масштаб відтворення',
  'set.render_scale_hint': 'Головний важіль кадру: менше — помітно швидше, але м’якше',
  'set.fish_distance': 'Дальність прибережної риби',
  'set.fish_distance_hint': 'Далі цієї межі риба не малюється',
  'set.vol_tackle': 'Снасть',
  'set.vol_steps': 'Кроки',
  'set.zoom': 'Крупність',
  'set.zoom_hint': 'Звужує огляд: предмети більші',
  'set.lang': 'Мова',
  'set.lang_ru': 'Русский',
  'set.lang_en': 'English',
  'set.lang_uk': 'Українська',
  'set.lang_es': 'Español',
  'lobby.settings': 'Налаштування',
  'lobby.min_level': 'Доступно з {level} рівня',
  'set.tab_sound': 'Звук',
  'set.tab_lang': 'Мова',
  'set.tab_account': 'Акаунт',
  'set.vol_music': 'Музика',
  'set.vol_effects': 'Звуки меню',
  'set.vol_note': 'Гучність зберігається на цьому пристрої і на інший не переноситься.',
  'unit.kg': 'кг',
  'unit.cm': 'см',
  'unit.m': 'м',
  'unit.g': 'г',
  'unit.mm': 'мм',
  'unit.coins': 'мон.',
  // ── Спорядження та магазин ──
  'slot.rod': 'Вудилище',
  'slot.reel': 'Котушка',
  'slot.line': 'Волосінь',
  'slot.lure': 'Принада',
  'menu.gear': 'Інвентар',
  'menu.shop': 'Садок',
  'menu.shop_sell': 'Садок',
  'keepnet.open_hint': 'Садок — натисни, щоб відкрити',
  'keepnet.title': 'Садок',
  'keepnet.full_warn': 'Садок повний — повернись на базу',
  'menu.shop_buy': 'Снасті',
  'menu.level': 'Рівень',
  'menu.max_level': 'межа',
  'menu.worn': 'одягнено',
  'menu.owned': 'куплено',
  'menu.need_level': 'потрібен рівень',
  'menu.slot_empty': 'Порожньо',
  'menu.keepnet_empty': 'У садку порожньо — половіть риби',
  'menu.sell': 'Продати',
  'menu.sell_all': 'Позначити все',
  'menu.sell_pick': 'Оберіть рибу',
  'menu.selling': 'Продаю…',
  'hud.caught_xp': '+{xp} досвіду',
  'hud.catch_rejected': 'Улов не записано',
  // ── Меню игры ──
  'menu.button': 'Меню',
  'menu.title': 'Меню',
  'menu.resume': 'Продовжити',
  'menu.locations': 'Локації',
  'menu.records': 'Рекорди',
  'menu.mine': 'Мої улови',
  'menu.settings': 'Налаштування',
  'menu.controls': 'Керування',
  'menu.logout': 'Вийти з облікового запису',
  'menu.graphics': 'Зображення',
  'menu.sound': 'Звук',
  'menu.game': 'Гра',
  'menu.quality': 'Якість',
  'menu.preset_low': 'Низька',
  'menu.preset_medium': 'Середня',
  'menu.preset_high': 'Висока',
  'menu.preset_custom': 'налаштування змінено вручну',
  'menu.reset': 'Скинути розділ',
  'menu.on': 'увімк',
  'menu.off': 'вимк',
  'menu.needs_reload': 'застосується після перезапуску',
  'menu.loading': 'Завантажую…',
  'menu.server_off': 'Сервер не відповідає',
  'menu.no_locations': 'Локацій поки немає',
  'menu.no_catches': 'Поки порожньо',
  'menu.need_login': 'Потрібен вхід',
  'menu.you_are_here': 'ви тут',
  'menu.ctl_move': 'Хода',
  'menu.ctl_run': 'Біг',
  'menu.ctl_jump': 'Стрибок',
  'menu.ctl_cast': 'Закид',
  'menu.ctl_reel': 'Підмотування',
  'menu.ctl_menu': 'Меню',
  'ui.title': 'InterFishing · Переглядач світу',
  'ui.gen_brush': 'Радіус пензля',
  'ui.gen_lift': 'Крок за натискання',
  'ui.sec_place': 'Що ставимо',
  'ui.btn_tree': 'Дерево',
  'ui.btn_bush': 'Кущ',
  'ui.btn_grass': 'Трава',
  'ui.btn_rock': 'Камінь',
  'ui.btn_reed': 'Очерет',
  'ui.btn_weed': 'Водорості',
  'ui.btn_erase': 'Стерти у колі',
  'ui.btn_loadmap': 'Завантажити карту',
  'ui.btn_savemap': 'Зберегти карту',
  'ui.btn_sizeup': 'Розмір +',
  'ui.btn_sizedown': 'Розмір −',
  'ui.help_make':
    'Наведи погляд на землю — жовте кільце покаже, куди ляже зміна.<br>    <kbd>Q</kbd> нижче · <kbd>E</kbd> вище · <kbd>Z</kbd> скасувати.<br>    В увімкненому будівництві <kbd>ЛКМ</kbd> повторює останню дію,<br>    а закидання не працює.<br /><br>    Зміни та предмети записуються у файл разом зі світом і переживають<br>    «Перезібрати»: вони лежать у світових координатах, а не в чанках.',
  'ui.help_play':
    '<kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> йти · <kbd>Shift</kbd> бігом ·<br>    <kbd>ЛКМ</kbd> дивитися<br /><br>    <b>Закидання помахом:</b> затиснути <kbd>ЛКМ</kbd>, миша <b>на себе</b>, потім<br>    <b>різко від себе</b>.<br /><br>    <b>Закидання після натискання:</b> тримати <kbd>ЛКМ</kbd> — кільце набирає силу,<br>    відпустити — летить. <b>Червоне</b> кільце: перебір, впаде під ноги.<br /><br>    На воді <kbd>ЛКМ</kbd> — підмотка.',
  'ui.unit_kg': 'кг',
  'ui.unit_cm': 'см',
  'ui.unit_g': 'г',
  'ui.unit_m': 'м',
  'ui.unit_mm': 'мм',
  'ui.tab_world': 'Світ',
  'ui.tab_gen': 'Творець',
  'ui.tab_make': 'Будівництво',
  'ui.btn_collapse': 'Згорнути',
  'ui.stat_chunks': 'Чанків',
  'ui.stat_queue': 'У черзі',
  'ui.stat_gen': 'Генерація',
  'ui.stat_tris': 'Трикутників',
  'ui.stat_fps': 'Кадр',
  'ui.stat_pos': 'Позиція',
  'ui.stat_alt': 'Висота',
  'ui.stat_seed': 'Сід',
  'ui.ctl_zoom': 'Масштаб',
  'ui.sec_weather': 'Небо і погода',
  'ui.stat_sun': 'Сонце',
  'ui.stat_sunrise': 'Схід',
  'ui.stat_sunset': 'Захід',
  'ui.stat_daylen': 'Тривалість дня',
  'ui.stat_vis': 'Видимість',
  'ui.stat_wind': 'Вітер',
  'ui.stat_wave': 'Хвиля',
  'ui.ctl_time': 'Час',
  'ui.ctl_weather': 'Погода',
  'ui.val_clear': 'ясно',
  'ui.ctl_force': 'Сила',
  'ui.btn_clock': 'Годинник йде',
  'ui.btn_wauto': 'Погода сама',
  'ui.sec_tackle': 'Снасть',
  'ui.stat_cast': 'Закидання',
  'ui.stat_tension': 'Натяг',
  'ui.stat_horizon': 'Горизонт',
  'ui.stat_depth': 'Глибина',
  'ui.stat_tip': 'Вершинка',
  'ui.stat_fish': 'Риба',
  'ui.sec_lure': 'Приманка',
  'ui.ctl_kind': 'Вид',
  'ui.val_spoon': 'коливалка',
  'ui.ctl_weight': 'Вага',
  'ui.ctl_dive': 'Заглиблення',
  'ui.ctl_bitex': 'Кльов ×',
  'ui.sec_line': 'Волосінь',
  'ui.ctl_mat': 'Матеріал',
  'ui.val_mono': 'монофіл',
  'ui.ctl_dia': 'Діаметр',
  'ui.stat_break': 'Розрив',
  'ui.sec_rod': 'Вудлище',
  'ui.ctl_class': 'Клас',
  'ui.val_medium': 'медіум',
  'ui.ctl_len': 'Довжина',
  'ui.ctl_test': 'Тест',
  'ui.ctl_action': 'Строй',
  'ui.val_mid': 'середній',
  'ui.sec_rodpose': 'Посадка вудлища',
  'ui.btn_tune': 'Регулювати',
  'ui.btn_std': 'Стандарт',
  'ui.btn_reset': 'Скинути',
  'ui.btn_sizedn': 'Розмір −',
  'ui.stat_pose': 'Посадка',
  'ui.sec_reelpose': 'Посадка котушки',
  'ui.btn_setup': 'Налаштувати',
  'ui.btn_save': 'Зберегти',
  'ui.btn_mode_reel': 'Режим: Котушка',
  'ui.sec_castmode': 'Спосіб закидання',
  'ui.btn_swing': 'Помахом',
  'ui.btn_newline': 'Нова волосінь',
  'ui.btn_shore': 'На берег',
  'ui.btn_newseed': 'Новий сід',
  'ui.tr_caught': 'Спіймана',
  'ui.btn_ok': 'ОК',
  'ui.language': 'Мова',
  'state.high': 'високо над водою — підійди до води',
  'state.reel_long': 'підмотка довгого звису',
  'state.click_water': 'натискання на воді',
  'state.click': 'натискання',
  'state.no_swing': 'відпустили без змаху',
  'state.reel_hang': 'підмотка: приманка висить',
  'state.reel_water': 'підмотка: приманка на воді',
  'state.release': 'відпустив',
  'state.line_end': 'закінчилася волосінь',
  'state.line_break': 'обрив на {kg} кг',
  'state.came_off': 'зійшла',
  'state.hooked_reel': 'сіла на підмотці {kind}',
  'state.strike': 'підсікання {kind} {kg} кг',
  'state.strike_slack': 'підсікання по слабині',
  'state.hooked_auto': 'сіла сама {kind} {kg} кг',
  'state.spit': 'виплюнула',
  'state.bite': 'клювання {kind} {kg} кг',
  'state.attack': 'атака риби',
  'state.attack_school': 'атака зграйної {kind} {kg} кг',
  'state.jump': 'свічка',
  'state.lost_tear': 'порвала губу — фрикціон туго',
  'state.lost_slack': 'зійшла на слабині',
  'state.lost_jump': 'стряхнула на свічці',
  'state.beached': 'риба на березі',
  'state.landed': 'взята {kg} кг',
  'state.lost_why': 'сход: {why}',
  'state.lost_swing': 'сход на змаху',
  'state.splash': 'приводнення',
  'state.reeled_slack': 'доматано до звису',
  'state.reset': 'повне скидання снасті',
  'state.in_air': 'у повітрі',
  'state.on_bottom': 'на дні',
  'state.floating': 'на плаву',
  'state.in_water': 'у товщі',
  'hud.tab.world': 'СВІТ',
  'hud.tab.generator': 'ГЕНЕРАТОР',
  'hud.tab.creator': 'ТВОРЕЦЬ',
  'hud.sec.map': 'КАРТА',
  'hud.sec.sky': 'НЕБО І ПОГОДА',
  'hud.sec.tackle': 'СНАСТЬ',
  'hud.sec.lure': 'ПРИМАНКА',
  'hud.sec.line': 'ВОЛОСІНЬ',
  'hud.sec.rod': 'ВУДЛИЩЕ',
  'hud.sec.rodPose': 'ПОСАДКА ВУДЛИЩА',
  'hud.sec.reelPose': 'ПОСАДКА КОТУШКИ',
  'map.chunks': 'Чанків',
  'map.generation': 'Генерація',
  'map.frame': 'Кадр',
  'map.height': 'Висота',
  'map.seed': 'Сід',
  'map.position': 'Позиція',
  'map.scale': 'Масштаб',
  'map.inQueue': 'У черзі',
  'map.triangles': 'Трикутників',
  'sky.sun': 'Сонце',
  'sky.sunrise': 'Схід',
  'sky.sunset': 'Захід',
  'sky.dayLength': 'Тривалість дня',
  'sky.visibility': 'Видимість',
  'sky.wind': 'Вітер',
  'sky.wave': 'Хвиля',
  'sky.time': 'Час',
  'sky.weather': 'Погода',
  'sky.strength': 'Сила',
  'sky.clockRunning': 'Годинник йде',
  'sky.weatherAuto': 'Погода сама',
  'weather.clear': 'ясно',
  'weather.cloudy': 'хмарно',
  'weather.fog': 'туман',
  'weather.rain': 'дощ',
  'sun.behind': 'за спиною',
  'sun.day': 'день',
  'sun.night': 'ніч',
  'tackle.cast': 'Закидання',
  'tackle.depth': 'Горизонт',
  'tackle.rodTip': 'Вершинка',
  'tackle.fish': 'Риба',
  'tackle.tension': 'Натяг',
  'tackle.waterDepth': 'Глибина',
  'tackle.ready': 'готовий',
  'tackle.floating': 'на плаву',
  'tackle.left': 'вліво',
  'tackle.right': 'вправо',
  'lure.kind': 'Вид',
  'lure.weight': 'Вага',
  'lure.diving': 'Заглиблення',
  'lure.noLip': 'немає лопаті',
  'lure.spoon': 'коливалка',
  'lure.spinner': 'оберталка',
  'lure.wobbler': 'воблер',
  'lure.jig': 'джиг',
  'line.material': 'Матеріал',
  'line.diameter': 'Діаметр',
  'line.breaking': 'Розрив',
  'line.dragTo': 'фрикціон до',
  'line.mono': 'монофіл',
  'line.fluoro': 'флюорокарбон',
  'line.braid': 'плетінка',
  'rod.class': 'Клас',
  'rod.length': 'Довжина',
  'rod.test': 'Тест',
  'rod.action': 'Строй',
  'rod.ultralight': 'ультралайт',
  'rod.light': 'лайт',
  'rod.medium': 'медіум',
  'rod.heavy': 'хеві',
  'action.slow': 'повільний',
  'action.medium': 'середній',
  'action.fast': 'швидкий',
  'btn.adjust': 'Регулювати',
  'btn.standard': 'Стандарт',
  'btn.reset': 'Скинути',
  'btn.sizePlus': 'Розмір +',
  'btn.sizeMinus': 'Розмір -',
  'btn.tune': 'Налаштувати',
  'btn.cancel': 'Скасувати',
  'btn.save': 'Зберегти',
  'outcome.landed': 'Улов',
  'outcome.lost': 'Схід',
  'outcome.break': 'Обрив',
  'outcome.tackle': 'Снасть',
  'lobby.wiki': 'Енциклопедія',
  'lobby.wiki_sub': 'усі види риб у грі',
  'wiki.who': 'Хто це',
  'wiki.where': 'Де шукати',
  'wiki.how': 'На що ловити',
  'wiki.no_rod': 'вудкою не ловиться',
  'wiki.when': 'Коли клює',
  'wiki.bite': 'Як клює',
  'rare.массовая': 'масова',
  'rare.обычная': 'звичайна',
  'rare.нечастая': 'нечаста',
  'rare.редкая': 'рідкісна',
  'rare.очень_редкая': 'дуже рідкісна',
  'rare.единичная': 'поодинока',
  'wiki.water': 'Вода',
  'wiki.spawn': 'Нерест',
  'wiki.water_band': 'від {a} до {b} °C · найкраще {opt} °C',
  'wiki.teeth': 'ріже волосінь — потрібен повідець',
  'act.дневная': 'удень',
  'act.ночная': 'вночі',
  'act.сумеречная': 'на зорях',
  'act.круглосуточная': 'цілодобово',
  'flow.стоячая': 'стояча вода',
  'flow.слабое': 'слабка течія',
  'flow.сильное': 'сильна течія',
  'flow.любое': 'будь-яка течія',
  'place.трава': 'трава',
  'place.коряги': 'корчі',
  'place.бровка': 'бровка',
  'place.твёрдое_дно': 'тверде дно',
  'place.ил': 'мул',
  'place.камни': 'каміння',
  'place.открытая_вода': 'відкрита вода',
  'place.поверхность': 'поверхня',
  'place.перекат': 'перекат',
  'place.яма': 'яма',
  'school.одиночка': 'тримається одинаком',
  'school.малая_стая': 'невеликою зграйкою',
  'school.большая_стая': 'щільним косяком',
  'wiki.size': 'Зазвичай {t}, до {max}',
  'wiki.length': 'довжина близько {n}',
  'wiki.horizon': 'Горизонт {a} – {b} м',
  'wiki.retrieve': 'Проводка {a} – {b} м/с',
  'wiki.window': 'На підсічку {n} с',
  'wiki.strike': 'Підсічка {n} м/с',
  'wiki.k_hard': 'різка',
  'wiki.k_mid': 'звичайна',
  'wiki.k_soft': 'мʼяка',
  'mouth.плёночная': 'губа плівчаста',
  'mouth.тонкогубая': 'губа тонка',
  'mouth.костистая': 'паща кістлява',
  'mouth.панцирная': 'паща з іклами',
  'mouth.кожистая': 'губа шкіряста',
  'mouth.хрящевая': 'рот-трубка хрящовий',
  'wiki.thick': 'товщина тіла {n} см',
  'wiki.soon': 'Ще не в грі',
  'wiki.soon_note': 'З’явиться з наповненням гри',
  'wiki.h_top': 'біля поверхні',
  'wiki.h_mid': 'у півводи',
  'wiki.h_deep': 'біля дна',
  'wiki.s_slow': 'повільна',
  'wiki.s_mid': 'середня',
  'wiki.s_fast': 'швидка',
  'wiki.w_short': 'часу мало',
  'wiki.w_ok': 'часу вистачає',
  'wiki.f_weak': 'слабка',
  'wiki.f_mid': 'жвава',
  'wiki.f_strong': 'сильна',
  'wiki.lip_soft': 'губа ніжна',
  'wiki.lip_mid': 'губа середня',
  'wiki.lip_hard': 'губа міцна',
  'wiki.stamina': 'тримається до {n} с',
  'wiki.jump_no': 'не свічить',
  'wiki.jump_rare': 'інколи свічить',
  'wiki.jump_often': 'часто свічить',
  'fam.карповые': 'коропові',
  'fam.лососёвые': 'лососеві',
  'fam.сиговые': 'сигові',
  'fam.окунёвые': 'окуневі',
  'fam.осетровые': 'осетрові',
  'fam.сомовые': 'сомові',
  'fam.щуковые': 'щукові',
  'fam.центрарховые': 'центрархові',
  'fam.бычковые': 'бичкові',
  'fam.вьюновые': 'в’юнові',
  'fam.корюшковые': 'корюшкові',
  'fam.миноговые': 'міногові',
  'fam.прочие': 'інші',
  'fam.сельдевые': 'оселедцеві',
  'fam.змееголовые': 'зміноголові',
  'fam.панцирниковые': 'панцирникові',
  'fam.цихловые': 'цихлові',
  'fam.харациновые': 'харацинові',
  'fam.ауховые': 'аухові окуні',
  'bait.мушка': 'штучна мушка',
  'bait.ручейник': 'личинка волохокрильця',
  'bait.икра': 'ікра',
  'bait.резка': 'різана риба',
  'bait.кузнечик': 'зелений коник',
  'bait.зелень': 'нитчасті водорості',
  'bait.лягушка': 'жаба',
  'bait.фрукт': 'фрукти',
  'bait.мясо': 'мʼясо',
  'bait.хлеб': 'хліб',
  'bait.червь': 'черв’як',
  'bait.опарыш': 'опариш',
  'bait.мотыль': 'мотиль',
  'bait.кукуруза': 'кукурудза',
  'bait.перловка': 'перлівка',
  'bait.тесто': 'тісто',
  'bait.горох': 'горох',
  'bait.бойл': 'бойл',
  'bait.пеллетс': 'пелетс',
  'bait.ракушка': 'скойка',
  'bait.живец': 'живець',
  'bait.рачок': 'рачок',
  'wiki.ingame': 'У грі',
  'wiki.find': 'Введіть назву',
  'wiki.nothing': 'Нічого не знайшлося',
  'wiki.red': 'Червона книга',
  'wiki.red_note': 'Вид під охороною. Таку рибу відпускають: у садок вона не потрапляє і не продається, але за впіймання йде досвід і окремий рядок у рекордах.',
  'lang.ru': 'RU',
  'lang.en': 'EN',
  'lang.uk': 'UK',
  'lang.es': 'ES',
  'ui.tab_gen_old': 'Генератор',
  'ui.tab_map_title': 'Карта світу: знайти справжню водойму',
  'ui.tab_map': 'Карта',
  'ui.btn_rebuild_title': 'Застосувати всі правки та перезібрати світ наново',
  'ui.btn_rebuild': 'Перестворити світ',
  'ui.unit_ms': 'мс',
  'ui.unit_mps': 'м/с',
  'ui.unit_beaufort': 'бал',
  'ui.stat_line_reserve': 'ЗАПАС ВОЛОСІНІ',
  'ui.stat_drag': 'ФРИКЦІОН',
  'ui.stat_reel': 'ПІДМОТКА',
  'ui.make_on': 'Будівництво УВІМК',
  'ui.make_off': 'Будівництво вимк',
  'ui.ready_to_cast': 'ДО ЗАКИДАННЯ ГОТОВИЙ',
  'state.has_edits': 'є правки — натисни «Перезібрати»',
  'state.world_built': 'світ зібрано',
  'state.rebuilding': 'перезбираю…',
  'rhumb.С': 'Пн',
  'rhumb.ССВ': 'ПнПнС',
  'rhumb.СВ': 'ПнС',
  'rhumb.ВСВ': 'СхПнС',
  'rhumb.В': 'Сх',
  'rhumb.ВЮВ': 'СхПдСх',
  'rhumb.ЮВ': 'ПдСх',
  'rhumb.ЮЮВ': 'ПдПдСх',
  'rhumb.Ю': 'Пд',
  'rhumb.ЮЮЗ': 'ПдПдЗ',
  'rhumb.ЮЗ': 'ПдЗ',
  'rhumb.ЗЮЗ': 'ЗхПдЗ',
  'rhumb.З': 'Зх',
  'rhumb.ЗСЗ': 'ЗхПнЗ',
  'rhumb.СЗ': 'ПнЗ',
  'rhumb.ССЗ': 'ПнПнЗ',
  'tackle.aim': 'замах',
  'tackle.flying': 'летить',
  'tackle.reeling': 'підмотка',
  'tackle.taut': 'натягнута',
  'tackle.slack': 'провис',
  'tackle.overload': 'ПЕРЕВАНТАЖЕННЯ',
  'tackle.straight': 'прямий',
  'ui.sec_pond': 'Водойма',
  'ui.sec_edge': 'Брівка',
  'ui.sec_bank': 'Берег',
  'ui.sec_relief': 'Рельєф навколо',
  'ui.sec_ground': 'Земля',
  'wind.calm': 'штиль',
  'wind.light_air': 'тихий',
  'wind.light_breeze': 'легкий',
  'wind.gentle_breeze': 'слабкий',
  'wind.moderate_breeze': 'помірний',
  'wind.fresh_breeze': 'свіжий',
  'wind.strong_breeze': 'сильний',
  'wind.near_gale': 'міцний',
  'wind.gale': 'шторм',
  'sun.dawn': 'світанок',
  'sun.dusk': 'захід',
  'sun.morning': 'ранок',
  'sun.evening': 'вечір',
  'sun.rel_face': 'в обличчя',
  'sun.rel_back': 'за спиною',
  'sun.rel_side': 'збоку',
  'sun.rel_below': 'за горизонтом',
  'tackle.drag_slipping': 'фрикціон здає',
  'tackle.hold': 'тримай',
  'tackle.beached': 'на березі',
  'tackle.strike_now': 'ПІДСІКАЙ',
  'ui.btn_done': 'Готово',
  'ui.btn_charge': 'За натисканням',
  'reel.mode_body': 'Режим: Корпус',
  'reel.mode_crank': 'Режим: Ручка',
  'reel.mode_bail': 'Режим: Скоба',
  'reel.mode_line': 'Режим: Точка волосіні',
  'state.world_built_already': 'світ вже зібрано за цими числами',
  'load.release_drag': 'ВІДПУСТИ ФРИКЦІОН',
  'load.charge_over': 'ПЕРЕБІР · ЗАКИДАННЯ ПІДЕ ПІД НОГИ',
  'load.charge_hold': 'НАБІР · ВІДПУСТИ ДЛЯ ЗАКИДАННЯ',
  'load.aim_swing': 'ЗАМАХ · ВЕДИ ВУДЛИЩЕМ',
  'load.trophy_hold': 'РИБА В РУКАХ · ВІДПУСТИ ЇЇ',
  'load.line_broken': "ВОЛОСІНЬ ОБІРВАНА · ПРИВ'ЯЖИ НОВУ",
  'load.long_hang': 'ДОВГИЙ ЗВІС · ДОМОТАЙ',
  'load.high_above_water': 'ВИСОКО НАД ВОДОЮ · ПІДІЙДИ ДО ВОДИ',
  'load.fish_nearby': 'ПОРУЧ РИБА - ОПУСТІТЬ НАЖИВКУ',
  'load.ready': 'ДО ЗАКИДАННЯ ГОТОВИЙ',
  'load.landed': 'ВЗЯТА',
  'load.lost': 'СХІД',
  'load.sagging': 'СЛАБИНА — КРУТИ!',
  'load.biting': 'ПОКЛЬОВКА — ПІДСІКАЙ!',
  'load.beached': 'НА БЕРЕЗІ · ЗМОТУЙ',
  'load.overload': 'ПЕРЕВАНТАЖЕННЯ · ВІДПУСТИ ФРИКЦІОН',
  'load.cast_dist': 'дальність {m} м',
  'load.depth': 'глибина {m} м',
  'load.bite_rate': 'шанс {p}%',
  'reel_dial.drag': 'ФРИКЦІОН',
  'reel_dial.reel': 'ПІДМОТКА',
  'line_dial.break': 'РОЗРИВ',
  'line_dial.left': 'ЗАПАС ЛІСКИ',
  'line_dial.broken': 'обрив',
  'ui.unit_km': 'км',
  'map.search_placeholder': 'Знайти водойму за назвою…',
  'map.search_btn': 'Шукати',
  'map.close_title': 'Закрити (Esc)',
  'map.attribution': '© учасники OpenStreetMap',
  'map.zoom': 'наближення',
  'map.status_searching': 'шукаю…',
  'map.status_error': 'не вийшло: {err}',
  'map.status_empty': 'нічого не знайдено',
  'map.status_found': 'знайдено {n}',
  'map.status_network': 'немає мережі: {err}',
  'minimap.tooltip': 'Карта водойми. Клік — відкрити на весь екран',
  'minimap.header': 'Карта',
  'minimap.close_title': 'Закрити · Esc',
  'minimap.zoom_in': 'Наблизити',
  'minimap.zoom_out': 'Віддалити',
  'minimap.across': 'всього {n} км впоперек',
  'minimap.legend_player': 'рибалка',
  'minimap.legend_barrier': 'кордон, далі не піти',
  'minimap.legend_depth': 'числа — глибина, м',
  'lure.no_lip': 'без лопаті',
  'tackle.drag_up_to': 'фрикціон до',
  'ui.status_saving': 'пишемо…',
  'ui.status_saved': 'переписано',
  'ui.status_save_err': 'не записати: немає сервера розробки',
  'ui.status_reset': 'скинуто',
  'ui.status_err': 'помилка запису',
  'ui.status_aim_ground': 'наведи на землю',

  // ── Лічба: форми числа. Їх обирає Intl.PluralRules, див. i18n.ts ──────
  'count.fish_few': '{n} риби',
  'count.fish_many': '{n} риб',
  'count.fish_one': '{n} риба',
  'count.fish_other': '{n} риб',
  'count.species_few': '{n} види',
  'count.species_many': '{n} видів',
  'count.species_one': '{n} вид',
  'count.species_other': '{n} видів',
  'count.records_few': '{n} записи',
  'count.records_many': '{n} записів',
  'count.records_one': '{n} запис',
  'count.records_other': '{n} записів',
  'count.items_few': '{n} предмети',
  'count.items_many': '{n} предметів',
  'count.items_one': '{n} предмет',
  'count.items_other': '{n} предметів',
  'count.waters_few': '{n} водойми',
  'count.waters_many': '{n} водойм',
  'count.waters_one': '{n} водойма',
  'count.waters_other': '{n} водойм',

  // ── Рибальська база: лобі ─────────────────────────────────────────────
  'lobby.waters': 'Водойми',
  'lobby.waters_sub': 'обери, куди поїдеш',
  'lobby.all_list': 'Весь список',
  'lobby.world_map': 'Карта Світу',
  'lobby.all_list_hint': 'Усі країни та водойми одним списком',
  'lobby.go': 'На рибалку',
  'lobby.no_country': 'Без країни',
  'lobby.list_failed': 'Не вдалося запитати сервер.',
  'lobby.list_failed_hint':
    'Водойми є, але список не прийшов: ігровий сервер не відповів. Це не порожня база — це обірваний зв’язок.',
  'lobby.empty': 'Водойм поки немає.',
  'lobby.empty_admin':
    'Обведи берег за справжньою картою — і він стане в цей список, а разом з ним відкриється й для всіх інших.',
  'lobby.empty_player':
    'Їх розмічає адміністратор за справжніми картами. Зазирни пізніше — перша вже готується.',
  'lobby.mirror': '{n} км² дзеркала',
  'lobby.across': '{n} км упоперек',
  'lobby.depth': 'глибина до {n} м',
  'lobby.no_fish': 'риби поки немає',
  'lobby.mapped': 'розмічений {when}',
  'lobby.base': 'Рибальська база',
  'lobby.level_short': '{n} рів.',
  'lobby.logout': 'Вихід',
  'lobby.trace_new': 'Обвести нову водойму за картою',
  'lobby.keepnet': 'Садок',
  'lobby.empty': 'Водойм поки немає.',
  'lobby.empty_admin':
    'Обведи берег за справжньою картою — і він стане в цей список, а разом з ним відкриється й для всіх інших.',
  'lobby.empty_player':
    'Їх розмічає адміністратор за справжніми картами. Зазирни пізніше — перша вже готується.',
  'lobby.mirror': '{n} км² дзеркала',
  'lobby.across': '{n} км упоперек',
  'lobby.depth': 'глибина до {n} м',
  'lobby.no_fish': 'риби поки немає',
  'lobby.mapped': 'розмічений {when}',
  'lobby.base': 'Рибальська база',
  'lobby.level_short': '{n} рів.',
  'lobby.logout': 'Вихід',
  'lobby.trace_new': 'Обвести нову водойму за картою',
  'lobby.keepnet': 'Садок',
  'lobby.keepnet_empty': 'вирушайте на рибалку і зловіть рибу',
  'lobby.xp': 'Досвід',
  'lobby.wallet': 'Гаманець',
  'lobby.wallet_info': 'Тут зберігаються ваші монети. Ловіть рибу, продавайте улов у магазині та купуйте нові снасті, щоб ловити ще більшу рибу!',
  'lobby.xp_line': '{level} рівень. До наступного рівня: {xp} досвіду.',
  'lobby.xp_info': 'Кожна спіймана риба приносить досвід. Чим більший і рідкісніший улов — тим більше досвіду. Підвищуйте рівень, щоб відкрити нові водойми!',
  'lobby.gold': 'Золото',
  'lobby.gold_info': 'Преміум валюта. Дозволяє купувати особливі снасті та бонуси.',
  'lobby.pack_starter_title': 'Стартовий набір',
  'lobby.pack_starter_desc': '100 Золота<br>250 Досвіду<br>1000 Монет',
  'lobby.pack_pro_title': 'Профі набір',
  'lobby.pack_pro_desc': '300 Золота<br>750 Досвіду<br>3000 Монет',
  'lobby.pack_master_title': 'Майстер набір',
  'lobby.pack_master_desc': '1000 Золота<br>2000 Досвіду<br>10000 Монет',
  'lobby.store_coming_soon': 'Покупки за реальні гроші скоро будуть доступні!',
    'lobby.wallet_line': '{coins} монет · {level} рівень, до наступного {xp} досвіду',
  'lobby.tackle': 'Рюкзак',
  'lobby.in_hands': 'У руках',
  'lobby.in_bag': 'У рюкзаку',
  'lobby.starter': 'стартове',
  'lobby.worn_now': 'Вдягнено: {name}',
  'lobby.records': 'Рекорди гравців',
  'lobby.records_none': 'поки ніким не встановлені',
  'lobby.mine': 'Мої улови',
  'lobby.open_wiki': 'відкрити в енциклопедії',
  'lobby.mine_none': 'історія поки порожня',
  'lobby.no_server': 'сервер не відповів',
  'lobby.shop': 'Магазин',
  'lobby.shop_sub': 'снасті, насадка, спорядження',
  'shop.sell': 'Продати улов',
  'shop.rod': 'Вудилища',
  'shop.reel': 'Котушки',
  'shop.line': 'Волосінь',
  'shop.leader': 'Повідці',
  'shop.hook': 'Гачки',
  'shop.lure': 'Принади',
  'shop.fly': 'Нахлист',
  'shop.bait': 'Наживка',
  'shop.groundbait': 'Прикормка',
  'shop.food': 'Їжа',
  'shop.keepnet': 'Садки',
  'shop.sonar': 'Ехолоти',
  'shop.boat': 'Човни',
  'shop.gear': 'Спорядження',
  'shop.soon': 'скоро',
  'lobby.shop_coins': 'У гаманці: {coins} мон.',
  'lobby.shop_sell': 'Продати улов',
  'lobby.shop_buy': 'Купити снасть',
  'lobby.shop_sold': 'Продано риб: {n}',
  'lobby.shop_bought': 'Куплено: {name}',
  'lobby.tours': 'Турніри',
  'lobby.tours_sub': 'змагання на час і на вагу',
  'lobby.club': 'Клуб рибалок',
  'lobby.club_sub': 'друзі, звання, спільні виїзди',
  'lobby.soon': 'скоро',
  'lobby.atlas': 'Куди поїдемо',
  'lobby.sheet_empty': 'Поки порожньо',
  'lobby.close': 'Закрити',
  'lobby.cancel': 'Скасувати',
  'lobby.logout_ask': 'Вийти з облікового запису?',
  'lobby.logout_note': 'Улов і снасті залишаться на місці. Щоб повернутися, знадобиться пошта й пароль.',
  'lobby.equipped': 'вдягнено · {slot}',
  'lobby.a_fish': 'риба',
  'lobby.account': 'Обліковий запис',
  'lobby.name': 'Ім’я',
  'lobby.name_hint': 'Це ім’я бачать інші гравці — у рекордах і на водоймі.',
  'lobby.name_save': 'Зберегти ім’я',
  'lobby.name_done': 'Тепер вас звати {name}',
  'lobby.pass_new': 'Новий пароль',
  'lobby.pass_min': 'Щонайменше 6 знаків',
  'lobby.pass_again': 'Повторіть пароль',
  'lobby.pass_again_hint': 'Ще раз',
  'lobby.pass_save': 'Змінити пароль',
  'err.pass_mismatch': 'Паролі не збігаються',
  'lobby.pass_done': 'Пароль змінено. Він знадобиться при наступному вході.',
  'lobby.lang': 'Мова гри',
  'lobby.email_note': 'Вхід поштою <b>{email}</b>. Її не бачить ніхто, окрім вас.',
  'lobby.account_hint': 'Налаштування облікового запису',
  'lobby.water_hint': 'Налаштування водойми',
  'lobby.fish_here': 'Яка риба тут водиться',
  'lobby.fish_note':
    'Знятий вид перестане клювати на цій водоймі. У нової водойми позначені всі — так вона одразу придатна для риболовлі.',
  'lobby.save': 'Зберегти',
  'lobby.fish_saved': 'Збережено: {list}',
  'lobby.fish_none_saved': 'Водойму залишено без риби',

  // ── Країни: ключ — код за ISO з даних карти, див. lobby.ts ────────────
  'country.ua': 'Україна',
  'country.de': 'Німеччина',
  'country.it': 'Італія',
  'country.ch': 'Швейцарія',
  'country.no': 'Норвегія',
  'country.si': 'Словенія',
  'country.fr': 'Франція',
  'country.se': 'Швеція',
  'country.ee': 'Естонія',
  'country.jp': 'Японія',
  'country.es': 'Іспанія',
  'country.pl': 'Польща',
  'country.lt': 'Литва',
  'country.lv': 'Латвія',
  'country.fi': 'Фінляндія',
  'country.cz': 'Чехія',
  'country.at': 'Австрія',
  'country.hu': 'Угорщина',
  'country.ro': 'Румунія',
  'country.gb': 'Велика Британія',
  'country.ie': 'Ірландія',
  'country.ca': 'Канада',
  'country.us': 'США',

  'key.lmb': 'ЛКМ',
  'key.rmb': 'ПКМ',

  'menu.tobase': 'Повернутися на базу',
  'menu.tobase_sure': 'Точно? Вийти до лобі?',

  // ── Відмови сервера. Ключ приїздить поруч із текстом, див. GameError ──
  'err.fill_all': 'Заповніть усі поля',
  'err.bad_credentials': 'Невірна пошта або пароль',
  'err.bad_email': 'Невірний формат пошти',
  'err.short_password': 'Пароль коротший за шість знаків',
  'err.keepnet_full': 'Садок повний: {cap} риб. Повернись на базу і продай улов',
  'err.weak_password': 'Пароль не за правилом: потрібні латиниця, цифра та велика літера',
  'err.user_exists': 'Користувач уже існує',
  'err.nothing_to_sell': 'Нема чого продавати',
  'err.already_sold': 'Ця риба вже продана',
  'err.no_such_item': 'Немає такого предмета',
  'err.not_for_sale': 'Цей предмет не продається',
  'err.need_login': 'Потрібен вхід',
  'err.need_level': 'Потрібен рівень {n}',
  'err.not_enough_coins': 'Не вистачає монет',
  'err.already_bought': 'Вже куплено',
  'err.wrong_slot': 'Не той слот',
  'err.item_not_owned': 'Цього предмета у вас немає',
  'err.no_water': 'Не вказано водойму',
  'err.no_fish_kinds': 'Не вказано види риби',
  'err.name_required': 'Введіть ім’я',
  'err.name_short': 'Ім’я закоротке: щонайменше {n}',
  'err.name_long': 'Ім’я задовге: щонайбільше {n}',
  'err.name_at': 'В імені не може бути знака @',
  'err.name_taken': 'Це ім’я вже зайняте',
  'err.no_account': 'Обліковий запис не знайдено',
  'err.no_answer': 'Сервер не відповів',

  // ── Администрирование игроков ──
  'adm.players': "Гравці",
  'adm.find': "Імя, пошта або IP",
  'adm.more': "Показати ще",
  'adm.total': "усього: {n}",
  'adm.loading': "вантажу…",
  'adm.settings': "Налаштування гравця",
  'adm.admin': "адмін",
  'adm.player': "гравець",
  'adm.banned': "заблокований",
  'adm.ok': "гаразд",
  'adm.never': "жодного разу",
  'adm.now': "зараз у грі",
  'adm.min_ago': "{n} хв тому",
  'adm.hour_ago': "{n} год тому",
  'adm.day_ago': "{n} дн тому",
  'adm.lvl': "рів. {n}",
  'adm.lvl_full': "Рівень",
  'adm.coins': "монет",
  'adm.fish': "риб",
  'adm.things': "Речей",
  'adm.role': "Роль",
  'adm.state': "Стан",
  'adm.registered': "Зареєстрований",
  'adm.seen': "Останній вхід",
  'adm.back': "до списку",
  'adm.give': "Нарахувати",
  'adm.rename': "Перейменувати",
  'adm.newpass': "новий пароль",
  'adm.setpass': "Змінити пароль",
  'adm.reason': "причина",
  'adm.ban': "Заблокувати",
  'adm.unban': "Розблокувати",
  'adm.make_admin': "Зробити адміном",
  'adm.make_player': "Розжалувати",
  'adm.last_catches': "Останні улови",
  'adm.logins': "Входи",
  'adm.failed': "невдача",
  'adm.sure': "Точно?",
  'adm.yes': "Так",

  // ── Гостевой вход ──
  'auth.or': "або",
  'auth.guest': "Гостьовий вхід",
  'lobby.logout_guest': "Гостьовий акаунт повернути не можна: пароля в нього немає. Рівень, монети, садок і рекорди зникнуть назавжди.",
  'lobby.guest_note': "Ви граєте гостем. Заведіть пошту й пароль — увесь поступ залишиться, а входити можна буде з будь-якого пристрою.",
  'lobby.guest_email': "Пошта",
  'lobby.guest_save': "Зробити постійним",
  'lobby.guest_done': "Готово: тепер це постійний акаунт",
  'adm.guest': "гість",
  'err.guest_many': "Забагато гостей з цієї адреси. Спробуйте пізніше",
  'err.not_guest': "Це вже постійний акаунт",
  'err.email_taken': "Така пошта вже зайнята",

  // ── Горячие клавиши ──
  'menu.ctl_gear': "Снасті",
  'menu.ctl_keepnet': "Садок",
  'menu.ctl_map': "Карта",

  // ── Качество картинки ──
  'set.q_max': "Максимум",
  'set.q_mid': "Середньо",
  'set.q_min': "Мінімум",
  'set.q_off': "Вимк",
  'set.reflection': "Відображення у воді",
  'set.reflection_hint': "Другий прохід усієї сцени за кадр. Найдорожчий пункт після масштабу: на слабкій машині вимкнення дає більше, ніж усе інше разом.",
  'set.shadows': "Тіні",
  'set.shadows_hint': "Каскадні тіні малюють світ заново по разу на каскад. Щабель нижче — це на один прохід по всіх деревах менше.",
  'set.vegetation': "Рослинність",
  'set.vegetation_hint': "Доки видно траву, очерет і кущі. Радіус удвічі менший — роботи вчетверо менше.",

  'set.clouds': "Хмари",
  'set.clouds_hint': "Рахуються по пікселю неба і повторюються у відображенні. Щаблі зменшують деталь шуму, а не самі хмари.",

  'load.bytes': "{done} з {total} МБ · {pct} %",

  'touch.cast': "Закид",

  'touch.reel': "Підмотка",

  'menu.map': "Мапа",

  'loader.мир': "Роззираюся",

  'load.bytes_only': "Завантажено {done} МБ",
  "load.file_line": "{name} · {size} МБ",
  "load.world_failed": "Водойма не відкрилася",
  "load.stalled": "Завантаження затягнулося",
  "load.back_to_lobby": "Повернутися до журналу",

  'touch.lamp': "Ліхтар",

  'set.hand': "Рука зі снастю",
  'set.hand_hint': "Ліва — кнопки ліворуч, прилади праворуч. Права — навпаки",
  'set.hand_left': "Ліва",
  'set.hand_right': "Права",

  'shop.float': "Поплавці",
  'slot.float': "Поплавець",
  'kit.спиннинг': "Спінінг",
  'kit.удочка': "Вудка",

  'item.cast': "закид до",

  'reel_dial.depth': 'ГЛИБИНА',
  'rod.float': 'махова',
  'rod.pole': 'штекерна',
  'rod.bolo': 'болонська',
  'rod.match': 'матчева',
  'rod.feeder': 'фідерна',
  'load.engine_failed': "Не вдалося завантажити гру. Оновіть сторінку.",
};
